module.exports = __webpack_public_path__ + "p_l.2c744ee5.png";